<!--
 * @Author: Lmi
 * @Description: 运维管理 现场人员 隐患排查列表
-->
<template>
  <scroll-layout class="hazard-investigation-list">
    <template slot="header">
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @clean="handleSearchClean"
        @click="handleSearchConfirm"></ykc-search>
    </template>
    <ykc-table
      ref="YkcTable"
      operateFixedType="right"
      :data="tableData"
      :title="tableTitle"
      :columns="tableColumns"
      :operateButtons="tableOperateButtons.filter(item => item.enabled())">
      <template #headerButtons>
        <div class="table-header-button">
          <ykc-button
            v-rbac="'maintain:personnel:hazardInvestigation:add'"
            type="plain"
            @click="add">
            新增
          </ykc-button>
          <ykc-button
            v-rbac="'maintain:personnel:hazardInvestigation:export'"
            type="plain"
            @click="doExportFile">
            导出
          </ykc-button>
        </div>
      </template>
      <ykc-pagination
        align="right"
        slot="pagination"
        ref="YkcPagination"
        :total="pageInfo.total"
        :page-size.sync="pageInfo.size"
        :current-page.sync="pageInfo.current"
        @size-change="handlePaginationSizeChange"
        @current-change="handlePaginationCurrentChange"></ykc-pagination>
    </ykc-table>
    <ykc-drawer
      title="隐患排查台账复检表新增"
      :show.sync="showDrawer"
      :on-close="onAddDrawerClose"
      :before-cancel="onAddDrawerCancel">
      <template #footer>
        <div class="drawer-button-wrap">
          <template v-for="(btn, i) in drawerButtons">
            <ykc-button :type="btn.type" v-if="btn.enabled()" :key="i" @click="btn.handler">
              {{ btn.label }}
            </ykc-button>
          </template>
        </div>
      </template>
      <div class="drawer-main-body" v-if="showDrawer">
        <AddOrEdit ref="addOrEdit"></AddOrEdit>
      </div>
    </ykc-drawer>
  </scroll-layout>
</template>
<script>
  import { offlineExport, code } from '@/utils';
  import { omManagementApi } from '@/service/apis';
  import YkcDialog from '@/components/ykc-ui/dialog';
  import AddOrEdit from './AddOrEdit.vue';

  export default {
    name: 'hazardInvestigationList',
    components: {
      AddOrEdit,
    },
    data() {
      return {
        stationId: null,
        showDrawer: false,
        maxIndex: 1,
        stepsIndex: 0,
        searchParams: {
          stationName: '',
          finishDateStart: '',
          finishDateEnd: '',
          responsiblePerson: '',
          inspectPerson: '',
          reviewPerson: '',
        },
        tableTitle: '复检列表',
        tableData: [],
        tableOperateButtons: [], // 列表操作
        tableColumns: [
          { label: '电站名称', prop: 'stationName', minWidth: '200px' },
          { label: '隐患', prop: 'danger', minWidth: '200px' },
          { label: '责任人', prop: 'responsiblePerson', minWidth: '200px' },
          { label: '检查人', prop: 'inspectPerson', minWidth: '200px' },
          { label: '整改期限', prop: 'endRectifyDate', minWidth: '200px' },
          {
            label: '整改情况',
            prop: 'rectifyFlag',
            scopedSlots: {
              default: ({ row }) => {
                return <span>{row.rectifyFlag === 1 ? '已整改' : '未整改'}</span>;
              },
            },
            minWidth: '200px',
          },
          {
            label: '复查情况',
            prop: 'reviewFlag',
            scopedSlots: {
              default: ({ row }) => {
                return <span>{row.reviewFlag === 1 ? '已完成' : '未完成'}</span>;
              },
            },
            minWidth: '200px',
          },
          { label: '复查人', prop: 'reviewPerson', minWidth: '200px' },
          { label: '完成时间', prop: 'finishDate', minWidth: '200px' },
        ],
        pageInfo: {
          current: 1,
          size: 10,
        },
        drawerButtons: [
          {
            label: '取消',
            type: 'plain',
            enabled: () => true,
            handler: () => {
              YkcDialog({
                dialogType: 'feedback',
                showTitle: false,
                showFooter: true,
                desc: '取消后操作将不被保存，确认是否取消？',
                onCancel: dialogDone => {
                  dialogDone(); // 隐藏弹窗
                },
                onConfirm: dialogDone => {
                  dialogDone(); // 隐藏弹窗
                  this.showDrawer = false; // 隐藏抽屉
                },
              });
            },
          },
          {
            label: '保存',
            enabled: () => true,
            handler: () => {
              this.$refs.addOrEdit.submitForm().then(() => {
                this.showDrawer = false;
                this.requestList();
              });
            },
          },
        ],
      };
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcInput',
            key: 'stationName',
            label: '电站名称',
            placeholder: '请输入电站名称',
          },
          {
            comName: 'YkcDatePicker',
            key: 'finishDate',
            label: '完成时间',
            placeholder: '请选择完成时间',
          },
          {
            comName: 'YkcInput',
            key: 'responsiblePerson',
            label: '责任人',
            placeholder: '请输入责任人',
          },
          {
            comName: 'YkcInput',
            key: 'inspectPerson',
            label: '检查人',
            placeholder: '请输入检查人',
          },
          {
            comName: 'YkcInput',
            key: 'reviewPerson',
            label: '复查人',
            placeholder: '请输入复查人',
          },
        ];
      },
    },
    created() {
      this.requestList();
      this.initData();
    },
    methods: {
      /**
       * 初始数据
       */
      initData() {
        this.tableOperateButtons = [
          {
            id: '2',
            text: '详情',
            enabled: () => code('maintain:personnel:hazardInvestigation:detail'),
            handleClick: (btn, { row }) => {
              this.$router.push({
                path: '/operationManagement/scenePersonnel/hazardInvestigation/Detail',
                query: { id: row.id },
              });
            },
          },
        ];
      },
      /**
       * 新增
       * */
      add() {
        this.stepsIndex = 0;
        this.showDrawer = true;
      },
      /**
       * 导出
       */
      doExportFile() {
        offlineExport(
          {
            downloadType: 'danger_check',
            jsonNode: {
              ...this.searchParams,
            },
          },
          this.pageInfo.total
        );
      },
      /**
       * 点击筛选查询按钮
       * */
      handleSearchConfirm(searchData) {
        console.log('searchData++++', searchData);
        Object.assign(this.searchParams, searchData);

        if (searchData.finishDate && searchData.finishDate.length > 0) {
          [this.searchParams.finishDateStart, this.searchParams.finishDateEnd] =
            searchData.finishDate;
        }
        this.pageInfo.current = 1;
        this.requestList();
      },
      /**
       * 点击清空查询按钮
       * */
      handleSearchClean(form) {
        Object.assign(this.searchParams, form);
        console.log('清空查询', form);
      },
      /**
       *
       * */
      handlePaginationCurrentChange(current) {
        this.pageInfo.current = current;
        this.requestList();
      },
      /**
       *
       * */
      handlePaginationSizeChange(size) {
        this.pageInfo.current = 1;
        this.pageInfo.size = size;
        this.requestList();
      },
      /**
       *
       * */
      onAddDrawerClose(done) {
        done();
      },
      /**
       * @desc 点击抽屉取消按钮 callback
       * */
      onAddDrawerCancel(drawerDone) {
        YkcDialog({
          dialogType: 'feedback',
          showTitle: false,
          showFooter: true,
          desc: '取消后操作将不被保存，确认是否取消？',
          onCancel: dialogDone => {
            dialogDone();
          },
          onConfirm: dialogDone => {
            dialogDone();
            drawerDone();
          },
        });
      },
      /**
       * 请求列表数据
       */
      requestList() {
        const reqParams = {
          ...this.searchParams,
          ...this.pageInfo,
        };
        omManagementApi
          .dangerCheckQuery(reqParams)
          .then(res => {
            this.tableData = res.records;
            this.pageInfo.total = res.total || 0;
          })
          .catch(err => {
            console.log(err);
          });
      },
    },
  };
</script>
<style lang="scss" scoped></style>
